import { render, staticRenderFns } from "./Contactanos.vue?vue&type=template&id=6ed82e00&scoped=true&"
import script from "./Contactanos.vue?vue&type=script&lang=js&"
export * from "./Contactanos.vue?vue&type=script&lang=js&"
import style0 from "./Contactanos.vue?vue&type=style&index=0&id=6ed82e00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed82e00",
  null
  
)

export default component.exports